import { Events, logEvent } from '../../utils/logging/events';
import { InstallButton } from './InstallButton';

export const Footer: React.FC = () => {
  const link = 'text-muted underline underline-offset-4 hover:text-peach';
  return (
    <footer className="mt-24 border-t border-line">
      <div className="mx-auto flex max-w-5xl flex-col justify-between gap-6 px-6 py-10 text-left text-ui md:flex-row md:items-center">
        <div className="font-display text-title">
          Marja<span className="text-peach">AI</span>
        </div>
        <nav className="flex flex-wrap gap-6">
          <a href="/about" className={link}>
            About us
          </a>
          <a
            href="mailto:salam@marja.ai"
            onClick={() => logEvent(Events.CONTACT_US_BUTTON)}
            className={link}
          >
            Join our team
          </a>
          <a href="mailto:salam@marja.ai" className={link}>
            salam@marja.ai
          </a>
          <InstallButton className={link} />
        </nav>
        <div className="text-caption text-muted-soft">
          © 2023–{new Date().getFullYear()} MarjaAI
        </div>
      </div>
    </footer>
  );
};
